import Navbar from "../../../common/Navbar/Navbar";
import Layout from "../../../common/layouts/Layout";
import IRBAdditionalSubmissionTable from "./Table/IRBAdditionalSubmissionTable";

const IRBAdditionalSubmissionsContainer = () => {
  return (
    <Layout>
      <>
        <Navbar pageTitle="MIRB Additional Submission" />
        <IRBAdditionalSubmissionTable />
      </>
    </Layout>
  );
};

export default IRBAdditionalSubmissionsContainer;
